var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "power-bank-2",
    "data-name": "Flat Line",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-line",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "secondary",
    x: 8,
    y: 5,
    width: 14,
    height: 10,
    rx: 1,
    transform: "translate(25 -5) rotate(90)",
    style: {
      fill: "#a9c6f4",
      strokeWidth: 0.672
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "primary",
    points: "15 12 16 10 14 10 15 8",
    style: {
      fill: "none",
      stroke: "#0f279f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.672
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-2",
    "data-name": "primary",
    d: "M5,9V20a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V17",
    style: {
      fill: "none",
      stroke: "#0f279f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.672
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-3",
    "data-name": "primary",
    d: "M19,17H11a1,1,0,0,1-1-1V4a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1V16A1,1,0,0,1,19,17ZM4,8H6V5H4Z",
    style: {
      fill: "none",
      stroke: "#0f279f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.672
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSvg);
export default __webpack_public_path__ + "static/media/power-svg.3c66c0211a73b5a43d238cb7897a1336.svg";
export { ForwardRef as ReactComponent };